// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"mainStyle_custom-scrollbar__nfTY3","table-header":"mainStyle_table-header__fCYN3","action_item":"mainStyle_action_item__JMiqR"};